<template>
  <ul class="nav nav-pills content-nav">
    <li
      v-for="tab in visibleTabs"
      :key="tab.to"
      :class="isActive(tab) && 'active'"
    >
      <router-link :to="tab.to">{{ tab.label }}</router-link>
    </li>
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'ContentNav',

  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },

  computed: {
    visibleTabs() {
      return this.tabs.filter(tab => tab.show !== false);
    },
  },

  methods: {
    isActive(tab) {
      if (tab.active !== undefined) return tab.active;
      return this.$route.path === tab.to;
    },
  },
};
</script>
